/* S4Y Lieferzeit · Weihnachtsferien (14.10.26, Daniel 12:36 + 12:37: „Lieferung Weihnachten ab dem 20.12. 3 Wochen on top, wegen Ferien“, Ferien bis 06.01.).
   Regel: Jeder angezeigte Liefertermin ab dem 20.12. verschiebt sich um 3 Wochen (Betriebsferien und Wiederanlauf).
   Wer in den Ferien bestellt (20.12. bis 09.01.), bekommt die normale Lieferzeit ab dem 10.01. gerechnet; ab dem 10.01. gilt wieder die normale Lieferzeit.
   Gilt jedes Jahr. Betrifft alle Lieferhinweise mit Wochenangabe (data-wmin/data-wmax: Produktseite, Konfigurator) und die Stellen,
   die diesen Text übernehmen (Preiszeile im Konfigurator). Eingebunden in sections/s4y-design.liquid.
   Ferienbeginn und Aufschlag hier anpassen: */
/* 15.10.26 (Daniel: „6-8 Wochen bei allen Designwerk“): Lieferzeit je Hersteller im Konfigurator. Der Konfigurator rechnet seinen
   Termin aus den Wochen der Section (Standard 10–12). Ist ein Modell eines Herstellers aus HERSTELLER_WOCHEN gewählt, gelten dessen
   Wochen, beim Wechsel auf ein anderes Modell wieder die der Section. „Produktionszeit ca. … Wochen“ in der Übersicht zieht mit. */
(function () {
  if (window.__s4yLz) return; window.__s4yLz = 1;
  var VON = [12, 20], PLUS_TAGE = 21; /* Ferienbeginn [Monat, Tag], Aufschlag in Tagen */
  var M = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  function plus(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function fd(d) { return d.getDate() + '. ' + M[d.getMonth()]; }
  /* gleiche Schreibweise wie im Konfigurator und auf der Produktseite */
  function spanne(a, b) { return a.getMonth() === b.getMonth() ? a.getDate() + '.–' + fd(b) : fd(a) + ' – ' + fd(b); }
  /* laufende oder nächste Ferien: Beginn s, Wiederanlauf e (Beginn + Aufschlag) */
  function ferien(h) {
    var y = h.getFullYear(), s = new Date(y - 1, VON[0] - 1, VON[1]), e = plus(s, PLUS_TAGE);
    if (h >= e) { s = new Date(y, VON[0] - 1, VON[1]); e = plus(s, PLUS_TAGE); }
    return { s: s, e: e };
  }
  /* gleiche Rechnung wie im Konfigurator und auf der Produktseite: heute + Wochen */
  function rechne(heute, wmin, wmax) {
    var effMax = wmax > wmin ? wmax : wmin + 1;
    var a = plus(heute, wmin * 7), b = plus(heute, effMax * 7), alt = spanne(a, b), f = ferien(heute);
    if (heute >= f.s) { a = plus(f.e, wmin * 7); b = plus(f.e, effMax * 7); }
    else { if (a >= f.s) a = plus(a, PLUS_TAGE); if (b >= f.s) b = plus(b, PLUS_TAGE); }
    return { alt: alt, neu: spanne(a, b) };
  }
  window.__s4yLzRechne = rechne;
  function termine(el) {
    var wmin = parseInt(el.getAttribute('data-wmin'), 10), wmax = parseInt(el.getAttribute('data-wmax'), 10);
    if (!wmin || !wmax) return null;
    return rechne(new Date(), wmin, wmax);
  }
  function ersetze(root, alt, neu) {
    if (!root || alt === neu) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) { if (n.nodeValue.indexOf(alt) !== -1) n.nodeValue = n.nodeValue.split(alt).join(neu); }
  }
  var HERSTELLER_WOCHEN = { designwerk: [6, 8] };
  function konfig(el) { var r = null; for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) if (p.id && p.id.indexOf('sk-') === 0) r = p; return r; }
  function hersteller(root) {
    var st = window.SK_STATE && window.SK_STATE[root.id.slice(3)], key = st && st.modelKey;
    var m = key && window.SK_MODULAR && window.SK_MODULAR[key];
    return m && m.hersteller ? String(m.hersteller).toLowerCase() : '';
  }
  function prodZeit(root, w) {
    var t = root && document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, re = /Produktionszeit ca\. \d+\s*[-–]\s*\d+ Wochen/;
    while (t && (n = t.nextNode())) { if (re.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(re, 'Produktionszeit ca. ' + w[0] + '–' + w[1] + ' Wochen'); }
  }
  function wochenJeModell() {
    var els = document.querySelectorAll('.sk-delivery-note[data-wmin][data-wmax]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], root = konfig(el);
      if (!root) continue;
      if (!el.hasAttribute('data-w0')) el.setAttribute('data-w0', el.getAttribute('data-wmin') + ',' + el.getAttribute('data-wmax'));
      var w0 = el.getAttribute('data-w0').split(',');
      var ziel = HERSTELLER_WOCHEN[hersteller(root)] || [parseInt(w0[0], 10), parseInt(w0[1], 10)];
      var a = parseInt(el.getAttribute('data-wmin'), 10), b = parseInt(el.getAttribute('data-wmax'), 10);
      if (!ziel[0] || !ziel[1] || (a === ziel[0] && b === ziel[1])) continue;
      var vorher = rechne(new Date(), a, b), jetzt = rechne(new Date(), ziel[0], ziel[1]).neu;
      el.setAttribute('data-wmin', ziel[0]); el.setAttribute('data-wmax', ziel[1]);
      ersetze(root, vorher.neu, jetzt); ersetze(root, vorher.alt, jetzt);
      prodZeit(root, ziel);
    }
  }
  function lauf() {
    try { wochenJeModell(); } catch (e) {}
    var els = document.querySelectorAll('[data-wmin][data-wmax]');
    for (var i = 0; i < els.length; i++) {
      var t = termine(els[i]);
      if (!t || t.alt === t.neu) continue;
      ersetze(els[i], t.alt, t.neu);
      /* Konfigurator: der Text wird in die Preiszeile und die Übersicht übernommen – ganzer Konfigurator (äußerstes Element mit id „sk-…“) */
      var r = null;
      for (var p = els[i].parentElement; p && p !== document.body; p = p.parentElement) if (p.id && p.id.indexOf('sk-') === 0) r = p;
      if (r) ersetze(r, t.alt, t.neu);
    }
  }
  function start() {
    lauf();
    if (!document.querySelector('[data-wmin][data-wmax]') || !window.MutationObserver) return;
    /* Texte, die später (neu) geschrieben werden, gleich mit anpassen */
    var plan = 0;
    new MutationObserver(function () { if (!plan) plan = setTimeout(function () { plan = 0; lauf(); }, 80); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();